// views.app.integrations

export const INTEGRATIONS = {
  title: 'Integrations',
  cardTitle: 'Accounts Connected',
  cardSubtitle: 'Accounts that have been connected.',
  connect: 'CONNECT ACCOUNTS'
};
